var _circle, _g, _circle2, _circle3, _circle4, _circle5, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreditCardPrimarySm = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 152,
  height: 118,
  fill: "none",
  viewBox: "0 0 152 118",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 52,
  r: 52,
  fill: "var(--utility-brand-100, black)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 115,
  height: 72,
  x: 18,
  y: 12,
  fill: "var(--utility-brand-100, black)",
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 15,
  x: 28,
  y: 26,
  fill: "var(--utility-brand-300, black)",
  rx: 1.667
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114.667,
  cy: 32.334,
  r: 8.333,
  fill: "var(--utility-brand-400, black)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104.667,
  cy: 32.333,
  r: 8.333,
  fill: "var(--utility-brand-300, black)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-300, black)",
  d: "M28 73.667c0-.92.746-1.667 1.667-1.667h16.666a1.667 1.667 0 1 1 0 3.333H29.667c-.92 0-1.667-.746-1.667-1.666M53 73.667c0-.92.746-1.667 1.667-1.667h16.666a1.667 1.667 0 1 1 0 3.333H54.667c-.92 0-1.667-.746-1.667-1.666M78 73.667c0-.92.746-1.667 1.667-1.667h16.666a1.667 1.667 0 1 1 0 3.333H79.667c-.92 0-1.667-.746-1.667-1.666M103 73.667c0-.92.746-1.667 1.667-1.667h16.666a1.667 1.667 0 1 1 0 3.333h-16.666A1.667 1.667 0 0 1 103 73.667"
}))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 5,
  r: 5,
  fill: "var(--utility-brand-100, black)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 109,
  r: 7,
  fill: "var(--utility-brand-100, black)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 35,
  r: 7,
  fill: "var(--utility-brand-100, black)"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 8,
  r: 4,
  fill: "var(--utility-brand-100, black)"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-400, black)",
  d: "M52 94c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--fg-white)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M76 90v4m0 4h.01M86 94c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: 148.333,
  height: 105.333,
  x: 1.333,
  y: 12,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 3.333,
  result: "effect1_dropShadow_1182_1744"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6.667
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.333
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1182_1744"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 3.333,
  result: "effect2_dropShadow_1182_1744"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 16.667
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_1182_1744",
  result: "effect2_dropShadow_1182_1744"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_1182_1744",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "b",
  width: 64,
  height: 64,
  x: 44,
  y: 62,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_1182_1744"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_1182_1744",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreditCardPrimarySm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CreditCardPrimarySm.02a46157e3e5a3e92b000110521d20bd.svg";